import ResourceList from "@/components/ResourceList";
import { Storefront } from "@phosphor-icons/react";

export default function Pharmacies() {
  return (
    <ResourceList
      title="Pharmacies"
      subtitle="Where refills live"
      resource="pharmacies"
      icon={Storefront}
      testidPrefix="pharmacies"
      emptyText="No pharmacies saved"
      itemTitle={(p) => p.name}
      itemSubtitle={(p) => [p.phone, p.hours].filter(Boolean).join(" · ")}
      itemBadge={(p) => p.address ? <div className="mt-2 text-sm text-[#576A62]">{p.address}</div> : null}
      fields={[
        { key: "name", label: "Pharmacy name", required: true, placeholder: "Green Cross Pharmacy" },
        { key: "phone", label: "Phone" },
        { key: "address", label: "Address" },
        { key: "hours", label: "Hours", placeholder: "Mon-Fri 9-9, Sat 10-6" },
        { key: "notes", label: "Notes", textarea: true },
      ]}
    />
  );
}
